import { Outlet } from 'react-router-dom';

import { SessionContext } from '@/contexts';
import { useBrand } from '@/hooks';
import { useContext } from 'react';
import { useEffect } from 'react';
import buildTheme from '@/theme';
import { Box, GlobalStyles, LinearProgress } from '@mui/joy';
import { useIsFetching, useIsMutating } from '@tanstack/react-query';
import { VBox } from '@/components/VBox';
import { useState } from 'react';

export default function Layout() {
  const { data: brand } = useBrand()

  const [brandId, setBrandId] = useState(null)

  const { setTheme } = useContext(SessionContext)

  const isMutating = useIsMutating()

  const isFetching = useIsFetching()

  useEffect(() => { 
    if (brand) {
      if (brandId === `aloaded:${brand.type}:${brand.id}`) {
        return
      }
      if (brand?.is_branded) {
        setTheme(buildTheme({
          themeType: 'label',
          borderRadius: brand.style?.borderRadius ?? 0,
          brandPrimary: brand.color,
          color: brand.style?.color,
          backgroundColor: brand.style?.backgroundColor
        }))
      } else {
        setTheme(buildTheme({
          themeType: 'ALOADED',
          brandPrimary: '#000',
          borderRadius: brand.style?.borderRadius ?? 0,
          color: brand.style?.color,
          backgroundColor: brand.style?.backgroundColor
        }))
      }  
      setBrandId(`aloaded:${brand.type}:${brand.id}`)
    }
  }, [brand])

  return (
    <>
      <GlobalStyles styles={() => brand?.style?.transitions ? ({
        '*': {
          '.MuiButton-root': {
            'transition': 'background-color 1s',
          },
          'transition': 'opacity .5s ease-in',
          '@media (prefers-reduced-motion: no-preference)': {
            'transition': `
              opacity .5s ease-in, 
              scale   .5s ease-in,
              display .5s ease-in,
              transform .5s ease-in
            `,
            transitionBehavior: 'allow-discrete'
          },
          '@starting-style': { 
            'opacity': 0,
            transform: 'translateY(-5pt)'
          },
          '&[hidden]': {
            opacity: 0,
            scale: .9,
            display: 'none !important',
            'transition-duration': '.4s',
            'transition-timing-function': 'ease-out'
          }
        },
      }) : ({})} />
      <VBox sx={{ display: 'flex', height: '100vh', flexDirection: 'column', gap: 0, flex: 1, overflow: 'hidden' }}>
        {/*<DeveloperBar />*/}
        {isFetching || isMutating ? <LinearProgress style={{ zIndex: 1000, position: 'fixed', left: 0, top: 0, width: '100%', flex: 0 }} /> : null}
        <Box sx={{ flex: 1 }}>
          <Outlet />
        </Box>
      </VBox>
    </>
  );
}